/* esm.sh - applesauce-loaders@5.1.0/loaders */
export * from "/*applesauce-loaders@5.1.0/esnext/loaders.mjs";
